import { httpRequest } from "@services/http";
import { SftpSettings } from "@models/SftpSettings.model";

export class CommandGetSftpSettings {
  async run(organizationId: number): Promise<SftpSettings> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/sftp/${organizationId}/settings`;
    const response = await httpRequest<any>(url, { method: "GET" });
    return SftpSettings.fromJson(response);
  }
}
